import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {},
  containerInner: {},
  pageContent: () => ({}),
}));

export default useStyles;
